import { Injectable } from "@angular/core";
import { HttpResponse } from "@angular/common/http";
import { LocalStoreManager } from "../services";
@Injectable()
export class RequestCacheService {
  constructor(protected sessionStorage: LocalStoreManager) {}
  get(key): HttpResponse<any> {
    const item = sessionStorage.getItem(key);
    if (item !== null) {
      const tuple = JSON.parse(item);
      if (!tuple) return null;
      const expires = tuple.expires;
      const httpResponse = tuple.value as HttpResponse<any>;
      // Don't observe expired keys
      const now = new Date();
      if (expires && new Date(expires).getTime() < now.getTime()) {
        this.delete(key);
        return null;
      }
      return httpResponse;
    }
    return null;
  }
  clear() {
    sessionStorage.clear();
  }
  delete(key) {
    sessionStorage.removeItem(key);
  }
  has(key: string): boolean {
    return sessionStorage.getItem(key) != null;
  }
  set(key, value, ttl = null) {
    try {
      if (ttl) {
        if (key.includes("GetMaxCode")) ttl = -10;

        const expires = new Date();
        expires.setSeconds(expires.getSeconds() + ttl);
        try {
          sessionStorage.setItem(key, JSON.stringify({ expires: expires, value: value }));
        } catch {}
      } else {
        sessionStorage.setItem(key, JSON.stringify({ expires: null, value: value }));
      }
    } catch (e) {
      console.log("Local Storage is full, Please empty data");
    }
  }
  hasValidCachedValue(key: string): boolean {
    if (this.has(key)) {
      const item = sessionStorage.getItem(key);
      const tuple = JSON.parse(item);
      const expires = tuple.expires;
      if (expires && new Date(expires).getTime() < Date.now()) {
        this.delete(key);
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
}
